import { Slot } from '@radix-ui/react-slot';
import { type ReactElement } from 'react';
import { cn } from '@avanta/shared/utils/cn';
import { Spinner } from '../Spinner';
import { buttonVariants } from './styles';
import { type ButtonProps } from './types';

const Button = ({
  className,
  variant,
  size,
  asChild = false,
  isLoading = false,
  children,
  icon,
  ...props
}: ButtonProps): ReactElement => {
  const Component = asChild ? Slot : 'button';

  return (
    <Component
      data-slot="button"
      className={cn(buttonVariants({ variant, size, icon, isLoading }), className)}
      disabled={isLoading || props.disabled}
      type={props.type ?? 'button'}
      {...props}
    >
      {isLoading ? <Spinner color="currentColor" size={25} stroke={3} /> : children}
    </Component>
  );
};

export { buttonVariants, Button, type ButtonProps };
